module.exports = __webpack_public_path__ + "static/media/ANGELO.65f47528.jpg";